(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.document.factory:Document
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcdocument')
    .factory('Document', Document);


  Document.$inject = ['restmod'];


  function Document(restmod) {
    return restmod.model('/routes/binarypdf', {
      $hooks: {
        'before-request': function (req) {
          console.log('before-fetch-many this, req: ', this, req);
          // this hook adapts the request to onlz return meta data, not the binary file content
          if (angular.isUndefined(req.params) || req.params === null) {
            req.params = {};
          }
          if (angular.isUndefined(req.params) || angular.isUndefined(req.params.options)) {
            req.params.options = {
              fields: {
                _id: true,
                created: true,
                type: true,
                filename: true,
                patientid: true,
                invoicenr: true,
                receiptnr: true,
                examid: true,
                clientid: true,
                consultid: true,
                keywords: true,
                flattags: true,
                date: true,
                isodate: true,
                examtype: true
              }
            };
          }

          console.log('before-fetch-many this, req: ', this, req);
        }
      }
    }).mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/binarypdf/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            let realquery = {active: {$ne: false}};
            realquery[key] = val;
            return this.$search({
              query: realquery,
              options: {
                fields: {
                  _id: true,
                  created: true,
                  type: true,
                  filename: true,
                  patientid: true,
                  invoicenr: true,
                  receiptnr: true,
                  examid: true,
                  clientid: true,
                  consultid: true,
                  keywords: true,
                  flattags: true,
                  date: true,
                  isodate: true,
                  examtype: true
                }
              }
            });
          },
          $searchMetaBy: function (key, val) {
            let realquery = {active: {$ne: false}};
            realquery[key] = val;

            return this.$search(
              {
                query: realquery,
                options: {
                  fields: {
                    _id: true,
                    created: true,
                    type: true,
                    filename: true,
                    patientid: true,
                    invoicenr: true,
                    receiptnr: true,
                    examid: true,
                    clientid: true,
                    consultid: true,
                    keywords: true,
                    flattags: true,
                    date: true,
                    isodate: true,
                    examtype: true
                  }
                }
              });
          },
          $getLast: function (patid, type) {
            let realquery = {active: {$ne: false}};
            realquery.patientid = patid;
            realquery.pdftype = type;

            return this.$search(
              {
                query: realquery,
                options: {
                  fields: {
                    file: false
                  },
                  sort: {_id: -1},
                  limit: 1
                }
              });
          }
        } // Model
      }// extend
    });
  }

// klammerfriedhof
}());
